import { useNavigate, useSearchParams} from "react-router-dom";
import { useGlobal } from "../../utils/GlobalContext";
import { useState, useEffect } from "react";
import { Button, Card, CardActions, CardContent, CardMedia, Grid, Typography } from "@mui/material";
import { newSession, session } from "../../data/session";
import SessionInfoModal from "../common/SessionInfoModal";
import { getEventById } from "../../services/cdn/Events";
//http://localhost:3000/sessions?e=dea90112c7a6&ss=9e1a2ec315aa
export default function Sessions() {
    const [queryParameters,setSearchParams] = useSearchParams();
    const { state, dispatch } = useGlobal();
    const navigate = useNavigate();
    const [onLoad, setOnLoad] = useState(false);
    useEffect(() => {
        if(onLoad===false && state.Conference.Name!==""){
            searchForSessionAndOpen(queryParameters.get("e")??"", queryParameters.get("ss")??"");
            queryParameters.delete('e');
            queryParameters.delete('ss');
            setSearchParams(queryParameters);
            setOnLoad(true);
        }
        if(state.Profiles.length && state.Profiles.length===0){
            return;
        }
        if (state.UserProfile.IsExistingUser === false && state.UserProfile.Id!=="") {
            navigate("/account");
        }
        if(onLoad===false && state.Conference.CurrentEventId===""
            && queryParameters.get("e")!==null&&queryParameters.get("e")!==""
            && queryParameters.get("ss")!==null&&queryParameters.get("ss")!==""){

            navigate(`/?e=${queryParameters.get("e")}&ss=${queryParameters.get("ss")}`);
            setOnLoad(true);
        }else if (onLoad===true && state.Conference.CurrentEventId===""){
            navigate("/");
        }
    });
    const searchForSessionAndOpen = async (eventId: string, sessionId: string) => {
        if(eventId===""||sessionId==="")
            return;
        const fullEventIds: string[] = state.Conference.Events.filter(function (el){
            return el.toUpperCase().endsWith(eventId.toUpperCase());
        });
        if(fullEventIds.length===0)
            return;
        const eventData = await getEventById(fullEventIds[0]); 
        if(eventData.Sessions.length!==0){
            const sessionsData: session[] = eventData.Sessions.filter(function (el){
                return el.Id.toUpperCase().endsWith(sessionId.toUpperCase());
            });
            if(sessionsData.length===0)
                return;
            handleSessionModalOpen(sessionsData[0])
        }
    };
    const [sessionInfoOpen, setSessionInfoOpen] = useState(false);
    const [selectedSession, setSelectedSession] = useState<session>(newSession());
    const handleSessionModalOpen = async (sessionData: session) => {
        setSelectedSession(sessionData);
        setSessionInfoOpen(true);
        queryParameters.delete('e');
        queryParameters.delete('ss');
        setSearchParams(queryParameters);
    };
    const handleSessionModalClose = () => {
        setSessionInfoOpen(false);
    };
    return (
        <div className="PageContainer">
            <Grid container spacing={2}>
            {
                state.SelectedEvent.Sessions?.sort((a,b)=>{return a.Title.toUpperCase()<b.Title.toUpperCase()?-1:1;}).map((sess) => (
                    <Grid item xs={6} md={2}>
                        <Card sx={{ maxWidth: 345 }} onClick={()=>handleSessionModalOpen(sess)} className="SessionCard">
                            <CardMedia
                                sx={{ height: 140}}
                                image={sess.SessionSpeakers!==null && sess.SessionSpeakers[0].PictureLink!== undefined && sess.SessionSpeakers[0].PictureLink!== null?sess.SessionSpeakers[0].PictureLink:"https://www.a-speakers.com/wp-content/uploads/profile-cover-generic-01-blue.jpg"}
                            />
                            
                            <CardContent className="SessionCardContent">
                                {sess.Title}
                            </CardContent>
                            {/* <CardActions>
                                <Button size="small">Share</Button>
                                <Button size="small">Learn More</Button>
                            </CardActions> */}
                        </Card>
                        <br/>
                    </Grid>
                    )
                )
            }
            </Grid>
            <SessionInfoModal show={sessionInfoOpen} onClose={handleSessionModalClose} sessionModel={selectedSession}/>
        </div>
    )
}